import React, { useState, useRef, useEffect } from "react";
import { Alert, Button, ButtonGroup, Dropdown, Form } from "react-bootstrap";

import PaymentDataContainer from "../Stores/PaymentDataContainerStore";
import { myGlobals, myUtilities } from "../Utils";
import { Subscribe } from "unstated";
import InvoiceDataContainer from "../Stores/InvoiceDataContainerStore";
import ACHCheckBox from "./ACHCheckBox";

const ModernAChForm = ({isAch, toShowTncForPayment, invoiceDataState, payDataState}) => {
  let achMandatoryFieldsList = invoiceDataState.bankTransferConfigFields;
  //to support stripe
  let countryCodeMassaging = "USA"
  if(achMandatoryFieldsList && typeof achMandatoryFieldsList === 'object' && achMandatoryFieldsList.length>0){
     countryCodeMassaging = "US";
  }

  const [bankAcctNum, setBankAcctNum] = useState();
  const [currentValueInEIPPDropdown, setCurrentValueInEIPPDropdown] = useState("");
  const [dynamicDropdownData, setDynamicDropdownData] = useState({});
  const [achMandateFields, setAchMandateFields] = useState();
  const [displayNameForDynamicDropdown, setDisplayNameForDynamicDropdown] = useState();
  const [allDropdownData, setAllDropdownData] = useState({});

  const myRef = useRef(null);
  const myRefBankAcc = useRef(null);
  const regExBank = new RegExp('(?!^0*$)[0-9]{6,}');
  const regExRouting = new RegExp("[0-9]{9}");

  const onBankAcctNum = ({ target: { value } }) => {
    if (myUtilities.numericAndBlackListedCheck("bankAccNo", true, value)) {
      if (!regExBank.test(value))
        myRefBankAcc.current.setCustomValidity(
          myUtilities.accountSpecificLanguage(
            "form.validation.error",
            "Please fill out this field."
          )
        );
      else myRefBankAcc.current.setCustomValidity("");
      setBankAcctNum(value);
    }
  };
  const setData = (copyOfDropDownData) =>{
      setDynamicDropdownData({...dynamicDropdownData,...copyOfDropDownData })
  };
	  useEffect(() => {
      if(invoiceDataState.bankTransferConfigFields){
         const  getBankTransferValues = async (dropdownFieldName,eachField) => {
            let options = [];
            let dropdownValue = "";
            let link = "getBankTransferFieldsDropdownValues";
            link = myGlobals.initialHost + myGlobals.appender + link;
            const searchParams = new URLSearchParams();
            searchParams.append('token', myGlobals.token);
            searchParams.append("dropdownStoreName", dropdownFieldName);

            return fetch(link, {
              method: "POST",
              body: searchParams,
            }) .then((response) => {
              if (response.status !== 200) {
                return;
              }
              return response.json();
            })
            .then((dropdownData) => {
              let modifiedData = []
              let copyOfDropDownData = {}
              dropdownData.rows.forEach((dropdown) => {
                modifiedData.push({"displayName": dropdown.displayName,"value" :  dropdown.value})
              })
              copyOfDropDownData[eachField.eippFieldDisplayName] = modifiedData
              setData(copyOfDropDownData);
            })
          }
          invoiceDataState.bankTransferConfigFields.forEach(eachField=>{
           if( eachField.fieldType == "inputdropdown"){
             getBankTransferValues(eachField.eippDbColumn+".BankFields",eachField);
           }
          })
          
       }
  }, []);
  useEffect(() => {
    let defaultData = {}
    let defaultValues = {}

    if(dynamicDropdownData && Object.keys(dynamicDropdownData) && Object.keys(dynamicDropdownData).length>0){
      Object.keys(dynamicDropdownData).forEach(key=>{
        defaultData[key]=dynamicDropdownData[key][0].displayName
        defaultValues[key]=dynamicDropdownData[key][0].value
        if(allDropdownData && !allDropdownData[key] ){
          setAllDropdownData({...allDropdownData,...dynamicDropdownData})
        }
      })
    }
    setDisplayNameForDynamicDropdown({...displayNameForDynamicDropdown,...defaultData});
    if(defaultValues && Object.keys(defaultValues) && Object.keys(defaultValues).length > 0){
       setAchMandateFields({
        ...achMandateFields,
        ...defaultValues
      })
    }
  },[dynamicDropdownData])
 
	const [bankName, setBankName] = useState();

	const onBankName = ({ target: { value } }) =>
	  myUtilities.numericAndBlackListedCheck("bankName", false, value)
	    ? setBankName(value)
	    : {};
	
	const [acctHolderName, setAcctHolderName] = useState();
	const onAcctHolderName = ({ target: { value } }) =>
	  myUtilities.numericAndBlackListedCheck("acctHolderName", false, value)
	    ? setAcctHolderName(value)
	    : {};
	
	const [routingNum, setRoutingNum] = useState();
	 const onRoutingNum = ({ target: { value } }) => {
		    if (myUtilities.numericAndBlackListedCheck("routingNum", true, value)) {
		      if (!regExRouting.test(value))
		        myRef.current.setCustomValidity(
		          myUtilities.accountSpecificLanguage(
		            "form.validation.error",
		            "Please fill out this field."
		          )
		        );
		      else myRef.current.setCustomValidity("");
		      if(value.length <= 9)
		      	setRoutingNum(value);
		    }
		  };

  const [acctType, setAcctType] = useState('Savings');
  // const onAcctType = ({ target: { value } }) => setAcctType(value);

  const [countryCode, setCountryCode] = useState(countryCodeMassaging);
  // const onCountryCode = ({ target: { value } }) => setCountryCode(value);
  
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  
  const [isTermsSelected, setIsTermsSelected] = useState(false);
  const toShowACHForm = toShowTncForPayment && toShowTncForPayment['ach'] ? isAch && isTermsSelected : isAch;

  const triggerTempAlert = (alertKey, alertMessage) => {
    setAlertMsg(myUtilities.accountSpecificLanguage(alertKey, alertMessage));
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  const checkAlertsBankAcc = () => {
    if(bankAcctNum?.toString().length < 6)
      triggerTempAlert('Validation.bankaccountNoSixCharcters', 'Account number must be minimum 6 digits');
    else if (/^0*$/.test(bankAcctNum?.toString()))
      triggerTempAlert('Validation.bankaccountNoOnlyZero', 'Account number can\'t have only zeros')
  }

  const checkRoutingNum = () => {
    if(routingNum?.toString().length !== 9)
      triggerTempAlert('Validation.RoutingNo', 'Please enter 9 digit routing number');
  }

  const onAchFormSubmit = (e, invData, payData) => {
    e.preventDefault();
    const dataToBePassed = {
      acctHolderName,
      bankName,
      routingNum,
      bankAcctNum,
      acctType,
      countryCode,
      achMandateFields,
    };
    payData.setDataForSending(invData, dataToBePassed);

    //used for partial giact success
    myGlobals.modernUXinvData = invData;
    myGlobals.modernUXdataToBePassed = dataToBePassed;
    myGlobals.triggermodernACHFlow = () => {
      payData.setDataForSending(myGlobals.modernUXinvData, myGlobals.modernUXdataToBePassed);
    }
  };

  const onChangeDynamicForm = (data,field) => {
    setAchMandateFields({
      ...achMandateFields,
      [field.eippFieldDisplayName]:data.currentTarget.value
    })
  }

  const handleChangeForEIPPDropdown = (eventVal, data, field) => {
    let displayValueSelected = eventVal;
    let value ;
    allDropdownData&& allDropdownData[field.eippFieldDisplayName] && allDropdownData[field.eippFieldDisplayName].forEach(f=>{
      if( f.displayName === eventVal){
        value =  f.value;
        
      return;
    }})
    setAchMandateFields({
      ...achMandateFields,
      [field.eippFieldDisplayName]:value
    })
    setDisplayNameForDynamicDropdown({
      ...displayNameForDynamicDropdown,
      [field.eippFieldDisplayName]:eventVal
    })
    setCurrentValueInEIPPDropdown(value)
  };
  let eachAchMandatoryField = [];
  const createDynamicFieldsForACHForm = (achMandatoryFieldsList,payData) =>{
     if(payData?.state?.countryCode && payData?.state?.countryCode != ""){
      achMandatoryFieldsList.forEach((field) => {
        if(field?.country && field.country == payData.state.countryCode){
          if(field.fieldType.toLowerCase() == "input") {
            eachAchMandatoryField.push(
              <Form.Group className="ach-form-grp">
                <Form.Label>
                  {" "}
                  {myUtilities.accountSpecificLanguage(
                    field.eippFieldMlKey,
                    field.eippFieldDisplayName
                  )}
                  {field.isMandatory ? <span className="red-asterisk">*</span> : null}
                </Form.Label>
                <Form.Control
                  type="text"
                  onChange={(evt)=>{onChangeDynamicForm(evt,field)}}
                  value= {myUtilities.accountSpecificLanguage(
                    "ACHForm." + field.eippDbColumn,
                    achMandateFields && achMandateFields[field.eippFieldDisplayName]
                    )}
                  required
                  ref={myRef}
                />
            </Form.Group>
            );
          } 
          else if (field.fieldType.toLowerCase() == "inputdropdown") {
            let mlKey = displayNameForDynamicDropdown? displayNameForDynamicDropdown[field.eippFieldDisplayName] : field.eippDbColumn;
            eachAchMandatoryField.push(
              <Form.Group className="ach-form-grp">
                <Form.Label>
                {myUtilities.accountSpecificLanguage(
                  field.eippFieldMlKey,
                  field.eippFieldDisplayName
                )}
                {field.isMandatory ? <span className="red-asterisk">*</span> : null}
                </Form.Label>
                <Dropdown
                  onSelect={(evt) => handleChangeForEIPPDropdown(evt, payDataState,field)}
                  className={"country-dropdown"}
                  as={ButtonGroup}
                >
                  <Button 
                    variant="success" 
                    name={field.eippFieldDisplayName}
                  >
                    <span>
                    {myUtilities.accountSpecificLanguage(
                      "ACHForm." + mlKey,
                      displayNameForDynamicDropdown && displayNameForDynamicDropdown[field.eippFieldDisplayName]
                      )}
                    </span>
                  </Button>

                  <Dropdown.Toggle
                    split
                    variant="success"
                  />

                  <Dropdown.Menu>
                    {
                    allDropdownData[field.eippFieldDisplayName] &&  allDropdownData[field.eippFieldDisplayName].map(eachEippFieldDisplayName=>{
                      return <Dropdown.Item eventKey= {eachEippFieldDisplayName.displayName} className={""}>
                        {myUtilities.accountSpecificLanguage(
                          "ACHForm." + eachEippFieldDisplayName.displayName,
                          eachEippFieldDisplayName.displayName
                        )}
                      </Dropdown.Item>
                      })
                    }
                
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>
            );
          }
      }
      });
      return eachAchMandatoryField;
  }
}

  const handleChange = (eventVal, data) => {
    let val = eventVal;
    data.populateInputData("countryCode", val);
  };

  const renderCountryCodeDropdown = (invdata) => {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(paymentData) => {
          return (
          <Dropdown
            onSelect={(evt) => handleChange(evt, paymentData)}
            className="country-dropdown"
            as={ButtonGroup}
          >
            <Button variant="success">
              <span>
                {myUtilities.accountSpecificLanguage(
                  "ACHForm.CountryCode." +
                  paymentData.getCurrentCountryCode(),
                  paymentData.getCurrentCountryCode()
                )}
              </span>
            </Button>

            <Dropdown.Toggle
              split
              variant="success"
              id="dropdown-split-curr"
            />

            <Dropdown.Menu>
              {populateCountryCodeOptions(invdata, paymentData)}
            </Dropdown.Menu>
          </Dropdown>
          );
        }}
      </Subscribe>
    );
  };

  const populateCountryCodeOptions = (invData, paymentData) => {
    let options = [];

    invData.state.achCountryDropdownValues.forEach((dropdown) => {
      let optionClass =
        paymentData.getCurrentCountryCode() === dropdown.value ? "clicked" : "";
      options.push(
        <Dropdown.Item
          className={optionClass}
          key={dropdown}
          eventKey={dropdown}

        //disabled={this.props && this.props.selectedCard && this.props.selectedCard == "ACH" && ((invData.state.processorName && invData.state.processorName.toLowerCase() === "stripe") || this.props.isStripeProcessor) && dropdown && dropdown.toUpperCase() === "CA" ? true : false}
        >
          {myUtilities.accountSpecificLanguage(
            "ACHForm.CountryCode." + dropdown,
            dropdown
          )}
        </Dropdown.Item>
      );
    });

    return options;
  };

  const renderAccountType = () => {
    return (
      <Dropdown
        onSelect={(evt, data) => setAcctType(evt)}
        className="ach-dropdown"
        as={ButtonGroup}
      >
        <Button variant="success">
          <span>
            {acctType === "Savings"
              ? myUtilities.accountSpecificLanguage(
                  "ACHForm.AccountType.Savings",
                  "Savings"
                )
              : myUtilities.accountSpecificLanguage(
                  "ACHForm.AccountType.Checking",
                  "Checking"
                )}
          </span>
        </Button>

        <Dropdown.Toggle split variant="success" id="dropdown-split-act" />

        <Dropdown.Menu>
          <Dropdown.Item
            eventKey="Savings"
            className={acctType === "Savings" ? "clicked" : ""}
          >
            {myUtilities.accountSpecificLanguage(
              "ACHForm.AccountType.Savings",
              "Savings"
            )}
          </Dropdown.Item>
          <Dropdown.Item
            className={acctType === "Checking" ? "clicked" : ""}
            eventKey="Checking"
          >
            {myUtilities.accountSpecificLanguage(
              "ACHForm.AccountType.Checking",
              "Checking"
            )}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <Subscribe to={[InvoiceDataContainer]}>
      {(invData) => (
        
         <Subscribe to={[PaymentDataContainer]}>
          {(payData) => (
            <Form
            
              onSubmit={(e) => onAchFormSubmit(e, invData, payData)}
              className="modern-ach-form"
              style={{margin:"0", padding:"0"}}
            >
            {showAlert && (
                    <Alert className="my-alert-class" variant="danger">
                      <p>{alertMsg}</p>
                    </Alert>
                  )}
            <ACHCheckBox invData={invData} callback={setIsTermsSelected}  />
              <fieldset disabled={!toShowACHForm}>
              <div className="mr-parent">
                <Form.Group className="ach-form-grp">
                  <Form.Label>
                    {myUtilities.accountSpecificLanguage(
                      "ACH.Form.Header.bankaccount",
                      "Bank Account Number"
                    )}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    onChange={onBankAcctNum}
                    value={bankAcctNum || ""}
                    required
                    onBlur={()=> checkAlertsBankAcc()}
                  	ref={myRefBankAcc}
                  />
                </Form.Group>
                <Form.Group className="ach-form-grp">
                  <Form.Label>
                    {" "}
                    {myUtilities.accountSpecificLanguage(
                      "ACHForm.AccountType",
                      "Account Type"
                    )}
                  </Form.Label>
                  {renderAccountType()}
                </Form.Group>
              </div>
              <div className="mr-parent">
                <Form.Group className="ach-form-grp">
                  <Form.Label>
                    {myUtilities.accountSpecificLanguage(
                      "ACH.Form.Header.bankname",
                      "Bank Name"
                    )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    onChange={onBankName}
                    value={bankName || ""}
                    required
                  />
                </Form.Group>

                <Form.Group className="ach-form-grp">
                  <Form.Label>
                    {" "}
                    {myUtilities.accountSpecificLanguage(
                      "ACH.Form.Header.countrycode",
                      "Country Code"
                    )}
                  </Form.Label>
                  {renderCountryCodeDropdown(invData)}
                </Form.Group>
              </div>

              <div className="mr-parent holder-div">
                <Form.Group className="ach-form-grp">
                  <Form.Label>
                    {myUtilities.accountSpecificLanguage(
                      "ACH.Form.Header.accountname",
                      "Account Holder's Name"
                    )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    onChange={onAcctHolderName}
                    value={acctHolderName || ""}
                    required
                  />
                </Form.Group>

                <Form.Group className="ach-form-grp">
                  <Form.Label>
                    {" "}
                    {myUtilities.accountSpecificLanguage(
                      "ACH.Form.Header.routingnumber",
                      "Routing Number"
                    )}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    onChange={onRoutingNum}
                    value={routingNum || ""}
                    required
                    onBlur={()=>checkRoutingNum()}
                  	ref={myRef}
                  />
                </Form.Group>
                {createDynamicFieldsForACHForm(achMandatoryFieldsList,payData)}
                
              </div>
              </fieldset>
              <div className="mr-parent">
                
                
                <Button disabled={!toShowACHForm}  variant="primary" type="submit">
                  {myUtilities.accountSpecificLanguage("pay", "Pay") +' ' + myUtilities.needCurrency("total")+  myUtilities.toStringUtil( invData.state.total,"total")}
                </Button>
              </div>
             
            </Form>
          )}
        </Subscribe>
      )}
    </Subscribe>
  );
};

export default ModernAChForm;
